import { shallowRef, triggerRef } from 'vue'
import _pick from 'lodash/pick'

const campaignNavigationRef = shallowRef({})

export function useCampaignNavigation () {
  const { $res } = useNuxtApp()
  return {
    campaignNavigationRef,
    getCampaignNavigation: () => campaignNavigationRef.value,

    clearCampaignNavigation () {
      campaignNavigationRef.value = {}
    },

    async fetchCampaignNavigation (plan) {
      if (!plan?.accountPlanId) return

      if (campaignNavigationRef.value[plan.accountPlanId]) return

      const response = await $res.fetch.structuredNavigation(plan.accountPlanId)
      if (response) {
        Object.entries(response).forEach(([channelId, campaigns]) => {
          response[channelId] = campaigns.map((cmp) =>
            _pick(cmp, ['accountPlanId', 'campaignPlanId', 'status', 'name', 'advertisingChannelId', 'partnerObjects']))
        })

        campaignNavigationRef.value = {
          ...campaignNavigationRef.value,
          [plan.accountPlanId]: response
        }
        triggerRef(campaignNavigationRef)
      }
    }
  }
}
